import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import PropTypes from 'prop-types';
import React from 'react';

import BtnIcon from '../framework/buttons/btn_icon';
import Clickable from '../framework/clickable';
import GroupLink from '../framework/group_link';
import PriceItem from '../shop/price_item';
import MarkerThumb from './marker-thumb';
import ProductShopButton from './product-shop-button';

const ProductItemSlim = ({
	currency,
	groups,
	markers,
	onAddToCart,
	page,
	price,
	price_discount,
	product_default,
	product_id,
	product_image,
	product_variant_id,
	slug,
	state,
	subtitle,
	title,
	tracking,
	type,
}) => {
	const id_key = `product-item-${product_variant_id}-${slug}`;

	return (
		<Clickable id={id_key}>
			<div className="mb-1 product-list-item position-relative border-bottom  px-3 px-lg-0 py-3">
				<div className="d-flex align-items-center justify-content-between">
					<div className="">
						<div className="d-flex align-items-center">
							{product_image && (
								<>
									<GatsbyImage
										alt={title}
										className="img-fluid thumb-sm me-2 bg-light"
										draggable="false"
										image={getImage(product_image)}
									/>
								</>
							)}
							{!product_image && (
								<MarkerThumb
									className="me-2"
									groups={groups}
									markers={markers}
									product_type={type}
									size="sm"
								/>
							)}
							<div>
								{subtitle && (
									<div className="list-subtitle mb-0 text-muted me-1">
										{subtitle}
									</div>
								)}
								<h3 className="text-primary-dark mb-0 product-item-slim-text title-small break-word">
									<GroupLink
										className="clickable text-decoration-none  text-primary-dark mb-0"
										groups={
											product_default?.group_id
												? [product_default?.group_id]
												: groups
										}
										page={page}
										product_id={product_id}
									>
										{title}
									</GroupLink>
								</h3>
							</div>
						</div>
					</div>
					<div className="price d-flex align-items-center">
						<p className="product-item-slim-text fw-700 mb-0 text-number me-1">
							<PriceItem
								currency={currency?.code}
								price={price}
								price_discount={price_discount}
							/>
						</p>

						{state != 'affiliate' && (
							<ProductShopButton
								onAddToCart={onAddToCart}
								product_id={product_id}
								tracking={tracking}
								variant="slim"
							/>
						)}

						{state == 'affiliate' && (
							<BtnIcon
								className="mt-1"
								groups={groups}
								linkType="group_link"
								page={page}
								product_id={product_id}
								variant="transparent"
							/>
						)}
					</div>
				</div>
			</div>
		</Clickable>
	);
};

ProductItemSlim.propTypes = {
	currency: PropTypes.object,
	excerpt: PropTypes.string,
	group_id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
	groups: PropTypes.array,
	markers: PropTypes.array,
	onAddToCart: PropTypes.func,
	page: PropTypes.string,
	price: PropTypes.string,
	price_discount: PropTypes.string,
	product_default: PropTypes.string,
	product_id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
	product_image: PropTypes.object,
	product_variant_id: PropTypes.number,
	slug: PropTypes.string,
	state: PropTypes.string,
	status: PropTypes.string,
	subtitle: PropTypes.string,
	title: PropTypes.string,
	tracking: PropTypes.object,
	type: PropTypes.string,
};

export default ProductItemSlim;
